var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M13.306 24.012c4.616.416 8.695-3.224 9.11-8.132.416-4.907-2.99-9.222-7.605-9.638-4.616-.416-8.695 3.224-9.11 8.132-.416 4.907 2.99 9.222 7.605 9.638z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.416 21.335a.533.533 0 0 1-.366-.16.51.51 0 0 1-.145-.365v-1.053l-.426-.083a3.514 3.514 0 0 1-.296-.065c-.5-.138-.943-.43-1.26-.834a2.342 2.342 0 0 1-.506-1.404v-.206c0-.138-.005-.273 0-.406a.496.496 0 0 1 .164-.324.517.517 0 0 1 .689 0c.094.084.153.2.164.324.006.12 0 .239 0 .357v.238c.006.355.152.695.408.947.255.253.6.399.963.408.181.006.364.009.547.01.213 0 .426 0 .638-.01a1.43 1.43 0 0 0 .907-.332 1.356 1.356 0 0 0 .293-1.758 1.405 1.405 0 0 0-.752-.597c-.373-.127-.75-.25-1.127-.373l-.15-.05c-.351-.113-.702-.225-1.05-.344a2.43 2.43 0 0 1-1.238-.867 2.344 2.344 0 0 1 .016-2.829 2.43 2.43 0 0 1 1.248-.852c.095-.025.51-.11.51-.11l.256-.056V9.49a.491.491 0 0 1 .138-.362.51.51 0 0 1 .562-.121.498.498 0 0 1 .322.466v1.111l.284.03c.56.056 1.082.298 1.481.686.226.214.405.47.53.753.123.282.189.586.192.893V13.537c0 .132-.053.26-.15.353a.517.517 0 0 1-.722 0 .495.495 0 0 1-.15-.353v-.575a1.356 1.356 0 0 0-.408-.962c-.26-.256-.612-.4-.981-.403a19.45 19.45 0 0 0-1.182 0 1.43 1.43 0 0 0-.9.34 1.374 1.374 0 0 0-.295 1.744c.166.277.426.488.734.596.614.212 1.23.41 1.845.605l.373.118c.54.137 1.016.451 1.349.89a2.354 2.354 0 0 1-.126 2.999c-.368.41-.869.685-1.418.778l-.455.069v1.019a.522.522 0 0 1-.277.525.527.527 0 0 1-.195.056l-.038-.001z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.005 15.152c0 4.92-3.87 8.87-8.596 8.87-4.727 0-8.596-3.95-8.596-8.87 0-4.918 3.869-8.868 8.596-8.868s8.595 3.95 8.595 8.869z",
    stroke: "url(#c)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.474 23.925a8.457 8.457 0 0 0 4.518-2.838 9.199 9.199 0 0 0 2.073-5.084A9.28 9.28 0 0 0 20.9 10.62C19.98 9.002 18.595 7.735 16.943 7a9.508 9.508 0 0 1 3.178 3.865 10.105 10.105 0 0 1 .854 5.036c-.15 1.73-.74 3.389-1.708 4.8a9.362 9.362 0 0 1-3.793 3.223z",
    fill: "#6AC34B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.991 2.61-3.04.85",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.174 5.144 6.221 1.7l-2.37 2.65 3.323.794z",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m18.01 27.391 3.04-.851",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m20.826 24.857.953 3.443 2.371-2.65-3.324-.793z",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.743,
    y1: 5.448,
    x2: 13.355,
    y2: 24.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 13.249,
    y1: 4.872,
    x2: 13.544,
    y2: 24.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 13.409,
    y1: 5.534,
    x2: 13.409,
    y2: 24.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.70cea0f683b4efe978aa937c8f1556f0.svg";
export { ForwardRef as ReactComponent };